interface Props {
  className?: string;
  'aria-hidden'?: boolean;
}

export function SearchIcon({ className = 'search-icon-svg', ...rest }: Props): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" className={className} {...rest}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}
